module.exports = __webpack_public_path__ + "static/media/vishwesh_pujari.ce7c1c15.jpg";